export const FISCAL_YEAR_END_MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const getFiscalYearEndLabel = (fiscalYearEndMonth: unknown): string => {
  let asNumber: number | null = null;

  if (typeof fiscalYearEndMonth === 'number' && Number.isInteger(fiscalYearEndMonth)) {
    asNumber = fiscalYearEndMonth;
  } else if (typeof fiscalYearEndMonth === 'string') {
    const trimmed = fiscalYearEndMonth.trim();
    if (/^\d+$/.test(trimmed)) {
      asNumber = Number(trimmed);
    }
  }

  if (asNumber !== null && asNumber >= 1 && asNumber <= 12) {
    return `${FISCAL_YEAR_END_MONTHS[asNumber - 1]} (month end)`;
  }

  return 'December (default)';
};
